import { Icon } from "@circle-react-shared/Icon";
import { SearchableSelect } from "@circle-react-uikit/SearchableSelect";
import { Typography } from "@circle-react-uikit/Typography";

export interface CreateLinkOptionProps {
  search: string;
  createLinkLabel?: string;
  onClick: () => void;
}

export const CreateLinkOption = ({
  search,
  createLinkLabel,
  onClick,
}: CreateLinkOptionProps) => (
  <SearchableSelect.Option onClick={onClick}>
    <div className="text-default flex flex-row items-center gap-2">
      <Icon type="20-add-md" size={20} aria-hidden color="text-secondary" />
      <div className="flex flex-1 flex-col gap-1">
        <Typography.LabelSm weight="medium">
          {createLinkLabel}
          {search && (
            <Typography.LabelSm weight="semibold">
              {` '${search}'`}
            </Typography.LabelSm>
          )}
        </Typography.LabelSm>
      </div>
    </div>
  </SearchableSelect.Option>
);
